var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVteXmsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 64.5,
    fill: "#F3F4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_90)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8689 82.5C66.1185 71.0987 56.6329 62.0834 45.0417 62.0834C43.5435 62.0834 42.0804 62.234 40.6667 62.521V50.4167C40.6667 47.195 43.2784 44.5834 46.5001 44.5834H87.3334C90.5551 44.5834 93.1668 47.195 93.1668 50.4167V76.6667C93.1668 79.8884 90.5551 82.5 87.3334 82.5H66.8689ZM84.838 49.949L66.9168 59.5989L48.9955 49.949C47.9318 49.3762 46.6052 49.7742 46.0324 50.8379C45.4596 51.9017 45.8576 53.2283 46.9213 53.8011L65.8797 64.0094C66.5271 64.358 67.3064 64.358 67.9538 64.0094L86.9122 53.8011C87.9759 53.2283 88.3739 51.9017 87.8011 50.8379C87.2283 49.7742 85.9017 49.3762 84.838 49.949Z",
    fill: "#BAF76A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3333 79.5834C53.9441 79.5834 55.2499 80.8892 55.2499 82.5V91.25C55.2499 92.8609 53.9441 94.1667 52.3333 94.1667H37.7499C36.1391 94.1667 34.8333 92.8609 34.8333 91.25V82.5C34.8333 80.8892 36.1391 79.5834 37.7499 79.5834V78.125C37.7499 74.098 41.0145 70.8334 45.0416 70.8334C49.0687 70.8334 52.3333 74.098 52.3333 78.125V79.5834ZM45.0416 73.75C42.6253 73.75 40.6666 75.7088 40.6666 78.125V79.5834H49.4166V78.125C49.4166 75.7088 47.4578 73.75 45.0416 73.75Z",
    fill: "#BAF76A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(29 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVteXmsgIcon);
export default __webpack_public_path__ + "static/media/VTEXmsgIcon.edf33b34ca839ddf8a3be9e9fe437e8f.svg";
export { ForwardRef as ReactComponent };